export default __webpack_public_path__ + "static/media/book-open-solid.83154b01.svg";